export default () => {
  const focusableSelector = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
  const focusNextElement = () => {
    const focusableElements = Array.from(document.querySelectorAll<HTMLElement>(focusableSelector));
    const currentIndex = focusableElements.indexOf(document.activeElement as HTMLElement);

    if (currentIndex > -1) {
      const nextElement = focusableElements[currentIndex + 1] || focusableElements[0];
      nextElement.focus();
    }
  };

  const focusPreviousElement = () => {
    const focusableElements = Array.from(document.querySelectorAll<HTMLElement>(focusableSelector));
    const currentIndex = focusableElements.indexOf(document.activeElement as HTMLElement);

    if (currentIndex > -1) {
      const prevElement = focusableElements[currentIndex - 1] || focusableElements[focusableElements.length - 1];
      prevElement.focus();
    }
  };

  const focusNextIndexElement = (index: number) => {
    const focusableElements = Array.from(document.querySelectorAll<HTMLElement>(focusableSelector));
    const currentIndex = focusableElements.indexOf(document.activeElement as HTMLElement);

    if (currentIndex > -1) {
      const nextElement = focusableElements[currentIndex + index] || focusableElements[0];
      nextElement.focus();
    }
  };

  const focusPreviousIndexElement = (index: number) => {
    const focusableElements = Array.from(document.querySelectorAll<HTMLElement>(focusableSelector));
    const currentIndex = focusableElements.indexOf(document.activeElement as HTMLElement);

    if (currentIndex > -1) {
      const prevElement = focusableElements[currentIndex - index] || focusableElements[focusableElements.length - index + currentIndex];
      prevElement.focus();
    }
  };

  return {
    focusNextElement,
    focusPreviousElement,
    focusPreviousIndexElement,
    focusNextIndexElement,
  };
};
